import { render } from "./ManageThemeStyle.vue?vue&type=template&id=02522734&lang=pug"
import script from "./ManageThemeStyle.vue?vue&type=script&lang=js"
export * from "./ManageThemeStyle.vue?vue&type=script&lang=js"

import "./ManageThemeStyle.vue?vue&type=style&index=0&id=02522734&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__